export default __webpack_public_path__ + "static/media/05_photo.1073100c.jpg";